import React from 'react'
import toggleOpen from 'local_modules/toggleOpen'
import cx from 'classnames'

import Box from 'components/layout/Box/Box'
import Collapsible from 'components/ui/Collapsible/Collapsible'
import ToggleArrow from 'components/ui/ToggleArrow/ToggleArrow'

import s from './CollapsibleList.scss'


const CollapsibleList = (props) => {
  const {
    children, className, titleClassName,
    title, isToggleActive, toggleOpen, toggleClose, withToggleArrow = true, isAbsolute,
  } = props

  return (
    <div className={cx(s.container, className)}>
      <Box
        className={cx(s.title, titleClassName)}
        pt="xs"
        pb="xs"
        pl="sm"
        onClick={() => {
          if (withToggleArrow) {
            if (isToggleActive) {
              toggleClose()
            }
            else {
              toggleOpen()
            }
          }
        }}
      >
        <Box
          pr={withToggleArrow ? 'xs' : null}
        >
          {title}
        </Box>
        {
          Boolean(withToggleArrow) && (
            <ToggleArrow direction={isToggleActive ? 'down' : 'up'} />
          )
        }
      </Box>
      <Collapsible
        className={cx({ [s.absolute]: isAbsolute })}
        collapsed={!isToggleActive}
        onClick={() => {
          if (withToggleArrow) {
            if (isToggleActive) {
              toggleClose()
            }
            else {
              toggleOpen()
            }
          }
        }}
      >
        {children}
      </Collapsible>
    </div>
  )
}


export default toggleOpen()(CollapsibleList)
